// Primary 2 English Learning Data
// Combined from p2Data-part1.js and p2Data-part2.js
// Based on Primary English Learning P2 Topics.txt

import { p2DataPart1 } from './p2Data-part1';
import { p2DataPart2 } from './p2Data-part2';

export const p2Data = {
  gradeId: p2DataPart1.gradeId,
  gradeName: p2DataPart1.gradeName,
  objectives: p2DataPart1.objectives,
  keySkills: p2DataPart1.keySkills,
  topics: [
    ...p2DataPart1.topics,
    ...p2DataPart2.topics
  ]
}; 